import { Component, OnInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { DataService_SoundMaintenance } from "./shared/data.service";
import { soundModel } from "./soundModel";
import { FileUpload } from "primeng/fileupload";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../shared";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolOrDistrictComponent } from "./school-or-district/school-or-district.component";
import { RecordSoundComponent } from "./record-sound/record-sound.component";
import { EditSoundComponent } from "./edit-sound/edit-sound.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-soundmaintenance",
	templateUrl: "./soundmaintenance.component.html",
	styleUrls: ["./soundmaintenance.component.css"],
})
export class SoundMaintenanceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private adminSetupService: DataService_SoundMaintenance,
		private confirmationService: ConfirmationService,
		private userService: UserService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		//TEST DATA
		// let val1: soundModel = {
		//   SoundLibraryID: -1,
		//   SoundName: "Test.mp3",
		//   Duration: "0:04",
		//   Date: new Date(),
		//   UsedBy: "All Schools"
		// }
		// this.lstSound.push(val1);

		this.loadSchoolist();
		//this.loadSoundList();

		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	subscription: any;

	user: any;

	loading: any = false;

	pagefirst: Number = 0;
	pagerows: Number = 10;
	SelectedSchool: any;
	SelectedSound: any;

	lstSchool: any = [];
	SoundDataList: any = [];
	lstSound: any = [];

	audio: any = new Audio();
	errorMessage: any;

	SoundToAdd: any = null;

	cols = [
		{ field: "SoundName", header: "Sound Name" },
		{ field: "Duration", header: "Duration" },
		{ field: "DateDesc", header: "Date" },
		{ field: "UsedBy", header: "Used By" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'ActiveDesc', header: 'Active' }
	];

	// lstUsedBy = [
	//   "This School Only",
	//   "District"
	// ]

	lstUsedBy: any = [];
	lstDefinedByDesc: any = [];
	lstActiveDesc: any = [];

	ToggleText: any = "Deactivate Sound";

	processing: any = false;

	///////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				// this.SelectedSchool = this.lstSchool[0].SchoolID;

				//Load sounds?
				this.loadSoundList();
			},
			(error) => {}
		);
	}

	private loadSoundList() {
		this.loading = true;
		var result = this.adminSetupService.loadSoundList("", this.SelectedSchool);
		result.subscribe(
			(response) => {
				this.lstSound = response;

				for (var z = 0; z < this.lstSound.length; z++) {
					var next = this.lstSound[z];

					next.DurationInt = Number(next.Duration);
				}

				this.lstUsedBy = Array.from(new Set(this.lstSound.map((item: any) => item.UsedBy))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstSound.map((item: any) => item.DefinedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstSound.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////
	onRefresh() {
		this.loadSoundList();
	}

	onAdd() {
		document.getElementById("AddSoundInput").click();
	}

	onBasicUpload(val) {} //////////////////////

	onDelete() {}

	onToggleActive() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.SelectedSound == undefined) {
			this.errorMessage = "Select a sound to activate or deactivate";
			return;
		}

		if (this.SelectedSound.DefinedByID < 3) {
			this.errorMessage = "System-Defined and Import-Defined sounds can't be toggled";
			return;
		}

		if (this.SelectedSound.DefinedByID == 4 && this.user.UserLevelID != 1) {
			this.errorMessage = "School users cannot activate or deactivate sounds created by district-level users";
			return;
		}

		this.processing = true;

		var changeTo = this.SelectedSound.Active == true ? 0 : 1;

		var result = this.adminSetupService.SoundLibraryToggle(this.SelectedSound.SoundLibraryID, changeTo);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					this.onRowUnselect(null);
					this.loadSoundList();
				} else {
					var MSG = "Could not ";

					if (changeTo == 0) {
						MSG += "deactivate ";
					} else {
						MSG += "activate ";
					}

					MSG += "the sound";

					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onPlaySound() {
		this.errorMessage = "";

		if (this.SelectedSound == null) {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		//Get Sound's data from DB
		var result = this.adminSetupService.loadSoundFile("", this.SelectedSound.SoundLibraryID);
		result.subscribe(
			(response) => {
				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	onStopSound() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	onConvertAll() {
		if (this.user.UserLevelID == 1) {
			var result = this.adminSetupService.convertAllWav("");
			result.subscribe(
				(response) => {
					if (response) {
						this.loadSoundList();
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "All WAV Files in the DB were converted successfully",
							header: "WAV Files Converted",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		}
	}

	onExport() {
		this.errorMessage = "";

		if (this.SelectedSound == null) {
			//Error message
			this.errorMessage = "Select a sound to export";

			return;
		}

		//Get Sound's data from DB
		var result = this.adminSetupService.loadSoundFile("", this.SelectedSound.SoundLibraryID);
		result.subscribe(
			(response) => {
				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Create and open link to the file w/ the correct file name
				var a = document.createElement("a");
				a.download = this.SelectedSound.SoundName;
				a.href = url;
				document.body.appendChild(a);
				a.click();
				a.remove();

				//Old way to Open file
				// var pwa = window.open(url, this.SelectedSound.SoundName);
			},
			(error) => {}
		);
	}

	onRecord() {
		var ref = this.dialogService.open(RecordSoundComponent, {
			header: "Record Sound",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			// if (response == 1)
			// {
			//   this.loadSoundList();
			// }

			this.loadSoundList();
		});
	}

	onEdit() {
		if (this.SelectedSound == undefined) {
			this.errorMessage = "Select a sound to edit";
			return;
		}

		if (this.SelectedSound.DefinedByID < 3) {
			this.errorMessage = "System-Defined and Import-Defined sounds can't be edited";
			return;
		}

		if (this.SelectedSound.DefinedByID == 4 && this.user.UserLevelID != 1) {
			this.errorMessage = "School users cannot edit sounds created by district-level users";
			return;
		}

		this.onStopSound();

		var ref = this.dialogService.open(EditSoundComponent, {
			header: "Edit Sound",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SelectedSchool,
				SelectedSound: this.SelectedSound,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSoundList();
			}
		});
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Events
	///////////////////////////////////////////

	onSoundToAddChange(val) {
		var file: File = val.target.files[0];

		if (file) {
			//Check if user is district user, and let them pick
			//if they want to add the sound at the school or district level
			if (this.user.UserLevelID == 1) {
				var entry;
				for (var x = 0; x < this.lstSchool.length; x++) {
					var next = this.lstSchool[x];
					if (next.SchoolID == this.SelectedSchool) {
						entry = next;
						break;
					}
				}

				var ref = this.dialogService.open(SchoolOrDistrictComponent, {
					header: "Add to School or District",
					width: "fit-content",
					data: {
						SchoolName: entry.SchoolName,
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 0) {
						this.AddSoundFile(file, -1); //Add to district
					} else if (response == 1) {
						this.AddSoundFile(file, this.SelectedSchool); //Add to selected school
					}
				});
			}
			//If school user add sound to selected school
			else {
				this.AddSoundFile(file, this.SelectedSchool);
			}
		}
	}

	AddSoundFile(file, schoolID) {
		//
		// File Name
		//

		var fileName = file.name;

		//
		// Sound Data
		//

		var soundData;
		var fr = new FileReader();
		fr.readAsDataURL(file);
		//fr.readAsBinaryString(file);

		//
		// Load Sound Data
		//
		fr.onload = () => {
			soundData = fr.result;

			//New Version

			//Check if file is a sound
			var AudioTest;
			try {
				AudioTest = new Audio(soundData);
			} catch (e) {
				AudioTest.onerror = (event) => {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Add Sound File. Not a Valid Audio File.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				};
			}

			AudioTest.oncanplaythrough = (event) => {
				//Finish Testing
				this.ContinueTesting(soundData, schoolID, fileName);
			};

			AudioTest.onerror = (event) => {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not Add Sound File. Not a Valid Audio File.",
					header: "ERROR",
					icon: "fa",
					accept: () => {},
				});
			};
		};
	}

	ContinueTesting(soundData, schoolID, fileName) {
		//Check if WAV (look at data)

		if (this.isWavCheck(fileName, soundData) == true) {
			if (this.CheckSizeLimit(soundData, "wav") == true) {
				//CALL SP to UPLOAD WAV
				this.loading = true;
				var result = this.adminSetupService.UploadSoundFile("", schoolID, fileName, soundData, "wav");
				result.subscribe(
					(response) => {
						this.loading = false;

						//
						// CONFIRM DIALOG FOR RESULTS
						//

						//File added successfully
						if (response) {
							this.confirmationService.confirm({
								acceptLabel: "Ok",
								rejectVisible: false,
								message: "WAV file added successfully",
								header: "Success",
								icon: "fa",
								accept: () => {},
							});

							this.loadSoundList();
						}
						//File not added (File name already in DB)
						else {
							this.confirmationService.confirm({
								acceptLabel: "Ok",
								rejectVisible: false,
								message:
									"Could Not Add Sound File. Server Cannot Convert WAV to Mp3 or there is a file with the same name is already in the Database.",
								header: "ERROR",
								icon: "fa",
								accept: () => {},
							});
						}

						// this.SelectedSound = null;
					},
					(error) => {}
				);
			} else {
				return;
			}
		} else if (this.isMP3Check(fileName, soundData)) {
			if (this.CheckSizeLimit(soundData, "mp3") == true) {
				this.loading = true;
				var result = this.adminSetupService.UploadSoundFile("", schoolID, fileName, soundData, "mp3");
				result.subscribe(
					(response) => {
						//
						// CONFIRM DIALOG FOR RESULTS
						//

						//File added successfully
						if (response) {
							this.confirmationService.confirm({
								acceptLabel: "Ok",
								rejectVisible: false,
								message: "Mp3 file added successfully",
								header: "Success",
								icon: "fa",
								accept: () => {},
							});

							this.loadSoundList();
						}
						//File not added (File name already in DB)
						else {
							this.confirmationService.confirm({
								acceptLabel: "Ok",
								rejectVisible: false,
								message: "Could Not Add Sound File. File with the same name is already in the Database.",
								header: "ERROR",
								icon: "fa",
								accept: () => {},
							});
						}

						// this.SelectedSound = null;
					},
					(error) => {}
				);
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Could Not Add Sound File. File is not a valid WAV or Mp3",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		}
	}

	CheckSizeLimit(soundData, type) {
		//WAV, 10MB limit
		if (type == "wav") {
			if (soundData.length / 1024 / 1024 > 10) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not Add Sound File. WAV file larger than 10 MB",
					header: "ERROR",
					icon: "fa",
					accept: () => {
						return false;
					},
				});
			} else {
				return true;
			}
		}
		//Mp3, 2MB limit
		else if (type == "mp3") {
			if (soundData.length / 1024 / 1024 > 2) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not Add Sound File. Mp3 file larger than 2 MB",
					header: "ERROR",
					icon: "fa",
					accept: () => {
						return false;
					},
				});
			} else {
				return true;
			}
		}
	}

	onSchoolChange(value) {
		this.errorMessage = "";

		this.SelectedSchool = value;

		//Update sounds
		this.loadSoundList();
	}

	onHandleFilter(value) {}

	onHandleSort(value) {}

	onRowSelect(value) {
		//Reset Error Message
		this.errorMessage = "";

		//Set selected Sound
		this.SelectedSound = value.data;

		this.ToggleText = "Deactivate Sound";

		if (this.SelectedSound.Active == false) {
			this.ToggleText = "Activate Sound";
		}
	}

	onRowUnselect(value) {
		this.errorMessage = "";

		this.ToggleText = "Deactivate Sound";

		//Set selected Sound
		this.SelectedSound = null;
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////

	dataURIToMP3Blob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "audio/mpeg" });
		return blob;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	isWavCheck
	//
	//-----------------------------------------------------------------------------------------------------
	isWavCheck(fileName: string, base64: string) {
		let isWav: boolean = false;
		let bytes: Uint8Array;

		//
		//	File Name must end in .wav
		//
		if (fileName.substr(-4, 4).toLowerCase() != ".wav".toLowerCase()) {
			return isWav;
		}

		bytes = this.base64StringToUint8Array(base64);

		//  The canonical WAVE format starts with the RIFF header:
		//
		//  Offset  Size Name       Description
		//  -----   ---- ---------- ------------------------------------------------------------------------
		//  0       4    ChunkID    Contains the letters "RIFF" in ASCII form (0x52494646 big - endian form).
		//  4       4    ChunkSize  36 + SubChunk2Size, or more precisely:
		//                          4 + (8 + SubChunk1Size) + (8 + SubChunk2Size)
		//                          This is the size of the rest of the chunk following this number.
		//                          This is the size of the entire file in bytes minus 8 bytes for the
		//                          two fields not included in this count: ChunkID and ChunkSize.
		//  8       4    Format     Contains the letters "WAVE" (0x57415645 big - endian form).
		if (
			bytes[0] == 0x52 &&
			bytes[1] == 0x49 &&
			bytes[2] == 0x46 &&
			bytes[3] == 0x46 &&
			bytes[8] == 0x57 &&
			bytes[9] == 0x41 &&
			bytes[10] == 0x56 &&
			bytes[11] == 0x45
		) {
			isWav = true;
		}

		return isWav;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	isMP3Check
	//
	//-----------------------------------------------------------------------------------------------------
	isMP3Check(fileName: string, base64: string) {
		let isMp3: boolean = false;
		let bytes: Uint8Array;

		//
		//	File Name must end in .mp3
		//
		if (fileName.substr(-4, 4).toLowerCase() != ".mp3".toLowerCase()) {
			return isMp3;
		}

		bytes = this.base64StringToUint8Array(base64);

		//
		// 	File starts with: 0x49 0x44 0x33		("ID3")
		//	or
		// 	File starts with: 0xFF 0xFB | 0xFF 0xF3 | 0xFF 0xE3 | 0xFF 0xFA | 0xFF 0xF2 | 0xFF 0xE2
		//
		// 	BITS					HEX			MPEG version ID								Layer		CRC Protection
		// 	-------------------		-----		---------------------------	------------	---------	-------------------------
		// 	11111111111 11 01 1		FF FB		MPEG Version 1								Layer III	Not protected	(No CRC)
		// 	11111111111 10 01 1		FF F3		MPEG Version 2								Layer III	Not protected	(No CRC)
		// 	11111111111 00 01 1		FF E3		MPEG Version 2.5 (not official standard)	Layer III	Not protected	(No CRC)
		//
		// 	11111111111 11 01 0		FF FA		MPEG Version 1								Layer III	Protected by CRC
		// 	11111111111 10 01 0		FF F2		MPEG Version 2								Layer III	Protected by CRC
		// 	11111111111 00 01 0		FF E2		MPEG Version 2.5 (not official standard)	Layer III	Protected by CRC
		//
		if (
			(bytes[0] == 0x49 && bytes[1] == 0x44 && bytes[2] == 0x33) ||
			(bytes[0] == 0xff && bytes[1] == 0xfb) ||
			(bytes[0] == 0xff && bytes[1] == 0xf3) ||
			(bytes[0] == 0xff && bytes[1] == 0xe3) ||
			(bytes[0] == 0xff && bytes[1] == 0xfa) ||
			(bytes[0] == 0xff && bytes[1] == 0xf2) ||
			(bytes[0] == 0xff && bytes[1] == 0xe2)
		) {
			isMp3 = true;
		}

		return isMp3;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	base64StringToUint8Array
	//
	//-----------------------------------------------------------------------------------------------------
	base64StringToUint8Array(base64: string) {
		if (base64.substr(0, 11) == "data:audio/") {
			base64 = base64.split(",")[1];
		}

		let binary_string = window.atob(base64);
		let len = binary_string.length;
		let bytes = new Uint8Array(len);

		for (let i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}

		return bytes;
	}

	///////////////////////////////////////////
}
